const mForgetPassword = {
  mForgetPassword: {
    alerts: {
      success: 'Se envió con éxito un correo a tu email para que sigas los pasos y recuperes tu contraseña.',
      error: 'Los datos ingresados son incorrectos.',
      user: 'Esta cuenta en Vidroop no existe. Escribe otra dirección de correo electrónico.'
    },

    buttonPrimary: 'RECUPERAR',

    descripcion: 'Escribe tu e-mail y te enviaremos a tu correo la posibilidad de introducir una nueva contraseña',

    formInfo: 'Recuperar Contraseña',

    goBack: 'Volver atrás',

    inputs: {
      email: {
        placeholder: 'Escribe tu e-mail'
      }
    },

    validation: {
      email: {
        email: 'El email ingresado no es una cuenta válida.',
        required: 'El email es requerido.'
      }
    }
  }
}

export default mForgetPassword
